
import { get } from '@bigyouth/base'
import { connectMenu } from 'instantsearch.js/es/connectors'

let initialSuggestions = null

const renderMenu = (renderOptions, isFirstRender) => {
  const { items, refine, createURL, widgetParams } = renderOptions

  let itemsList = items

  if (widgetParams.suggestionsWrap) {
    if (isFirstRender) {
      const ul = document.createElement('ul')
      ul.classList.add('ais-Menu-list')
      widgetParams.container.appendChild(ul)
    } else {
      if (initialSuggestions === null) {
        initialSuggestions = itemsList
      } else {
        itemsList = initialSuggestions
      }
    }

    widgetParams.container.querySelector('ul').innerHTML = itemsList.map((item) => `
      <li class="ais-Menu-item">
        <a href="${createURL(item.value)}" data-value="${item.value}" class="thematic thematic--big">
          ${item.label}
        </a>
      </li>`).join('')

    widgetParams.container.querySelectorAll('a').forEach((element) => {
      element.addEventListener('click', (event) => {
        event.preventDefault()
        refine(event.currentTarget.dataset.value)
        get('[js-training-list-panel][data-panel="subthemes"]').classList.add('is-visible')
      })
    })
  }
}

const customMenu = connectMenu(renderMenu)

export default customMenu
